import React from 'react'

// components
import {
  CCol,
  CFormLabel
} from '@coreui/react-pro'
import FormCheckboxInput from './FormCheckboxInput'

const FormBalanceAdjustmentType = ({
  id,
  type,
  colSize,
  className,
  inputLabel,
  value,
  handleCheck,
  disabled
}) => {
  return (
    <CCol lg={colSize} className={className}>
      {inputLabel && (
        <CFormLabel>
          {inputLabel} :
        </CFormLabel>
      )}
      <FormCheckboxInput
        id={id}
        name={'adjustment_type_accrual'}
        className={'mb-2'}
        type={type}
        label='Time-Off Accrual'
        handleCheck={handleCheck}
        disabled={disabled}
        value={value === 'accrual'}
      />
      <FormCheckboxInput
        id={id}
        name={'adjustment_type_deduction'}
        type={type}
        label='Time-Off Deduction'
        handleCheck={handleCheck}
        disabled={disabled}
        value={value === 'deduction'}
      />
    </CCol>
  )
}

export default FormBalanceAdjustmentType
